import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    showDrawer: false,
    formType: "",
    initialValues: null,
    pagination: {
        pageNo: 0,
        limit: 10,
        sortBy: "DESC",
        sortField: "created_at",
    },
    filters: {
        is_active: "",
        target_type: "",
        search: "",
    },
};

const alertsSlice = createSlice({
    name: "alerts",
    initialState,
    reducers: {
        changeAlertsInitialState: (state, action) => {
            const { showDrawer, formType, initialValues } = action.payload;

            state.showDrawer = showDrawer;
            if (formType) state.formType = formType;
            if (initialValues) state.initialValues = initialValues;
            if (!initialValues) state.initialValues = {};
        },
        handlePaginationState: (state, action) => {
            const { payload } = action;
            state.pagination = payload;
        },
        handleFiltersState: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetAlertsState: () => initialState,
    },
});

export const { changeAlertsInitialState, handlePaginationState, handleFiltersState, resetAlertsState } =
    alertsSlice.actions;

export default alertsSlice;
